// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.library_library-scroll-grid_GaYe9 {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  background: var(--ui-secondary);
  flex-grow: 1;
  flex-wrap: wrap;
  overflow-y: auto;
  height: auto;
  padding: 0.5rem;
  height: calc(100% - 3.125rem);
  &.library_padding_G2ZGB {
    padding: 30px 0 0 0;
  }
}

.library_library-scroll-grid_GaYe9.library_withFilterBar_lQrjP {
  height: calc(100vh - 3.125rem - 2.5rem - 2rem - var(--stage-fullscreen-top));
}

.library_filter-bar_WXJzs {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: calc(2.5rem + 2rem);
  /* padding */
  background-color: var(--looks-transparent);
  padding: 0 1rem;
  font-size: 0.875rem;
}

.library_filter-bar-item_b3StT {
  margin-right: 0.75rem;
}

.library_filter_QJgGj {
  flex-grow: 0;
}

.library_filter-input_cTGxO {
  width: 11.5rem;
  transition: 0.2s;
}

.library_filter-input_cTGxO:focus,
.library_filter-input_cTGxO:not([value='']) {
  width: 18.75rem;
}

.library_divider_vJM4Z {
  transform: scaleY(1.39);
  height: 2.5rem;
}

.library_tag-wrapper_z68dH {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 2.5rem;
  overflow: hidden;
}

.library_spinner-wrapper_OXCzr {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.library_unsupported-in-t-w-tip_DNYCP {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 5px;
  background: var(--looks-transparent);
  border-radius: 0 0 5px 5px;
  position: absolute;
  z-index: 999
}`, "",{"version":3,"sources":["webpack://./src/components/library/library.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB;AACF","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.library-scroll-grid {\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n  background: var(--ui-secondary);\n  flex-grow: 1;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  height: auto;\n  padding: 0.5rem;\n  height: calc(100% - 3.125rem);\n  &.padding {\n    padding: 30px 0 0 0;\n  }\n}\n\n.library-scroll-grid.withFilterBar {\n  height: calc(100vh - 3.125rem - 2.5rem - 2rem - var(--stage-fullscreen-top));\n}\n\n.filter-bar {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  height: calc(2.5rem + 2rem);\n  /* padding */\n  background-color: var(--looks-transparent);\n  padding: 0 1rem;\n  font-size: 0.875rem;\n}\n\n.filter-bar-item {\n  margin-right: 0.75rem;\n}\n\n.filter {\n  flex-grow: 0;\n}\n\n.filter-input {\n  width: 11.5rem;\n  transition: 0.2s;\n}\n\n.filter-input:focus,\n.filter-input:not([value='']) {\n  width: 18.75rem;\n}\n\n.divider {\n  transform: scaleY(1.39);\n  height: 2.5rem;\n}\n\n.tag-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  height: 2.5rem;\n  overflow: hidden;\n}\n\n.spinner-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.unsupported-in-t-w-tip {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  background: var(--looks-transparent);\n  border-radius: 0 0 5px 5px;\n  position: absolute;\n  z-index: 999\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"library-scroll-grid": `library_library-scroll-grid_GaYe9`,
	"libraryScrollGrid": `library_library-scroll-grid_GaYe9`,
	"padding": `library_padding_G2ZGB`,
	"withFilterBar": `library_withFilterBar_lQrjP`,
	"filter-bar": `library_filter-bar_WXJzs`,
	"filterBar": `library_filter-bar_WXJzs`,
	"filter-bar-item": `library_filter-bar-item_b3StT`,
	"filterBarItem": `library_filter-bar-item_b3StT`,
	"filter": `library_filter_QJgGj`,
	"filter-input": `library_filter-input_cTGxO`,
	"filterInput": `library_filter-input_cTGxO`,
	"divider": `library_divider_vJM4Z`,
	"tag-wrapper": `library_tag-wrapper_z68dH`,
	"tagWrapper": `library_tag-wrapper_z68dH`,
	"spinner-wrapper": `library_spinner-wrapper_OXCzr`,
	"spinnerWrapper": `library_spinner-wrapper_OXCzr`,
	"unsupported-in-t-w-tip": `library_unsupported-in-t-w-tip_DNYCP`,
	"unsupportedInTWTip": `library_unsupported-in-t-w-tip_DNYCP`
};
export default ___CSS_LOADER_EXPORT___;
